;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/Accordion',["jquery", "eventManager", 'loglevel', "cssEscape"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel'), require("cssEscape")) :
    console && console.error('Accordion does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function Accordion(scope, stateChangeMessages) {
        var self = this;
        Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

        //#region message transmitter registration
        if (stateChangeMessages.length) {
            this.$scope.on("shown.bs.collapse hidden.bs.collapse", function () {

                stateChangeMessages.forEach(function (eventName) {
                    log.debug("Accordion raises message: \'%s\'", eventName);

                    eventManager.trigger(eventName, self);
                });

                return false;
            });
        }
        //#endregion

        this._setupDeepLinking();
    }

    Accordion.prototype._setupDeepLinking = function () {
        var that = this;
        // make accordion panel with anchors change the URL to make them sticky
        this.$scope.on('shown.bs.collapse',
            function (e) {
                var anchor = '';
                var oldHash = window.location.hash.substring(1);

                var anchorLink = $(e.target).closest('.panel').find('a[data-toggle="collapse"][href*="#collapse-"][data-anchorable="True"]');
                if (anchorLink.length) {
                    anchor = anchorLink.attr("href").replace("#collapse-", "");
                }

                if (anchor) {
                    window.history && window.history.pushState && window.history.pushState(null, null, '#' + anchor);
                    window.location.hash = anchor;
                } else {
                    // if we open a panel without deep linking, we should release previously selected anchorable panel.
                    if (oldHash && $(e.target).closest('.panel-group').find('a[data-toggle="collapse"][href*="#' + CSS.escape('collapse-' + oldHash) + '"][data-anchorable="True"]').length) {
                        // clear hash without page jump in modern browsers
                        window.history && window.history.pushState && window.history.pushState(null, null, '');
                        window.location.hash = '';
                    }
                    // otherwise we don't care.
                }
            });

        // make all tabs with anchors to be visible when we walk along the browser history
        $(window).on("hashchange", function () {
            if (!window.location.hash) return !1;
            
            // find a tab which should be activated within current tabset. otherwise keep tabset without any changes.
            var panel = that.$scope.find('a[href="#' + CSS.escape('collapse-' + window.location.hash.substring(1)) + '"]');
            if (panel.length) {
                panel.trigger("click");
            }
        });
    }


    Accordion.init = function init(args) {
        return args.IsEditorEditing === true ? null : new Accordion(args.scope, args.StateChangeMessagesTransmitting || []);
    };

    return Accordion;
}));
